// extracted by mini-css-extract-plugin
module.exports = {"group":"form_group_group__3YDyU","title":"form_group_title__1xrBM","content":"form_group_content__2M7Jf"};